import { ESalesType } from '../types/offersData';

import {
  IconFinanceSale16,
  IconPlaceholderAgent16,
  IconProductDateTime16,
  IconProductTopSeller16,
  IconProductVasPremium16,
} from '@cian/ui-kit-design-tokens/icons';

export const SALES_TYPE_ICONS = new Map<ESalesType, React.ReactNode>([
  [ESalesType.UpcomingSale, <IconProductDateTime16 key={ESalesType.UpcomingSale} color="icon-secondary-default" />],
  [ESalesType.SalesStart, <IconProductVasPremium16 key={ESalesType.SalesStart} color="icon-secondary-default" />],
  [ESalesType.SalesLeader, <IconProductTopSeller16 key={ESalesType.SalesLeader} color="icon-secondary-default" />],
  [ESalesType.ConsultantPage, <IconPlaceholderAgent16 key={ESalesType.ConsultantPage} color="icon-main-default" />],
  [ESalesType.PromoIndexPage, <IconFinanceSale16 key={ESalesType.PromoIndexPage} color="icon-main-default" />],
]);
